window['landing_page_first_load'] = true;
window['eq-pdp-page-update'] = function () {
    setupGallery();
    onElementReady('.product__thumbs--square', () => {
        if (!document.querySelector('#spice-thumb')) {
            document.querySelectorAll('[data-thumbs-slider]').forEach(el => el.setAttribute('id', 'spice-thumb'));
        }
        if (!document.querySelector('#spice-flickity')) {
            document.querySelectorAll('[data-product-slideshow]').forEach(el => el.setAttribute('id', 'spice-flickity'));
        }
        jQuery('#spice-thumb .thumb, #spice-thumb .thumb a').removeClass('is-selected').off('click').on('click', function (e) {
            e.preventDefault();
            jQuery('#spice-thumb').flickity('select', $(this).data('order'));
        });
        jQuery('#spice-thumb').flickity({
            contain: true, pageDots: false, on: {
                change: function (index) {
                    themeVendor.FlickityFade("#spice-flickity").select(index);
                }
            }
        });
        destroyFlickity();
        initFlickity(() => {
            if (typeof jQuery === 'function') {
                    jQuery('#spice-thumb .thumb, #spice-thumb .thumb a').eq(0).trigger('click');
                } else {
                    console.warn('jQuery is not loaded.');
                }
        });
    });

    const colorRadios = document.querySelectorAll('input[name="options[Color]"], input[name="options[Colour]"]');
    const colorLabel = document.querySelector('.selector-wrapper[data-select-position="1"] .radio__legend label');

    function updateLabelWithSpan(labelElement, selectedValue) {
        if (!labelElement) return;
        let valueSpan = labelElement.querySelector('.selected-value');
        if (!valueSpan) {
            valueSpan = document.createElement('span');
            valueSpan.className = 'selected-value';
            labelElement.appendChild(valueSpan);
        }
        valueSpan.textContent = ` ${selectedValue}`;
    }

    function updateColorLabel() {
        const selectedColor = document.querySelector('input[name="options[Color]"]:checked, input[name="options[Colour]"]:checked')?.value || '';
        updateLabelWithSpan(colorLabel, selectedColor);
    }

    if (colorRadios.length > 0) {
        colorRadios.forEach(radio => {
            radio.addEventListener('change', () => {
                updateColorLabel();
                setupGallery();
            });
            radio.addEventListener('click', () => {
                updateColorLabel();
                setupGallery();
            });
        });
    }

    updateColorLabel();
    onElementReady('.eq-pdp-section .jdgm-prev-badge__text', updateBeforeAfterImages);
};

function setupGallery() {
    const colorInputs = document.querySelectorAll('input[name="options[Color]"], input[name="options[Colour]"]');
    colorInputs.forEach(input => {
        input.addEventListener('change', () => {
            setTimeout(() => {
                destroyFlickity();
                initFlickity(() => {
                    if (typeof jQuery === 'function') {
                    jQuery('#spice-thumb .thumb, #spice-thumb .thumb a').eq(0).trigger('click');
                } else {
                    console.warn('jQuery is not loaded.');
                }
                });
                const variantId = document.querySelector('[data-product-form] input[name="id"]').value;
                const variantSelect = document.getElementById('select_before_after_image');
                if (variantSelect) {
                    const matchingOption = Array.from(variantSelect.options).find(option => option.value === variantId);
                    if (matchingOption) {
                        variantSelect.value = variantId;
                        const beforeImage = document.querySelector('#before-image img');
                        const afterImage = document.querySelector('#after-image img');
                        const selectedImages = document.querySelector(`#select_before_after_image option[value="${variantSelect.value}"]`);
                        if (selectedImages) {
                            beforeImage.src = selectedImages.dataset.beforeImage;
                            afterImage.src = selectedImages.dataset.afterImage;
                        }
                    }
                }
            }, 300);
        });
    });

    const colorSelected = document.querySelector('input[name="options[Color]"]:checked, input[name="options[Colour]"]:checked');
    if (colorSelected) {
        setTimeout(() => {
            destroyFlickity();
            initFlickity(() => {
                if (typeof jQuery === 'function') {
                    jQuery('#spice-thumb .thumb, #spice-thumb .thumb a').eq(0).trigger('click');
                } else {
                    console.warn('jQuery is not loaded.');
                }
            });
        }, 300);
    }
}

function destroyFlickity() {
    const spiceThumb = document.querySelector('#spice-thumb.flickity-enabled');
    if (spiceThumb?.flickityInstance) {
        spiceThumb.flickityInstance.destroy();
        spiceThumb.flickityInstance = null;
    }
    const spiceFlickity = document.querySelector('#spice-flickity.flickity-enabled');
    if (spiceFlickity?.flickityInstance) {
        spiceFlickity.flickityInstance.destroy();
        spiceFlickity.flickityInstance = null;
    }
    if (typeof themeVendor !== 'undefined' && themeVendor.FlickityFade) {
        const flickFade = themeVendor.FlickityFade('#spice-flickity.flickity-enabled');
        if (flickFade) flickFade.destroy();
    }
}

function initFlickity(callback) {
    if (typeof themeVendor !== 'undefined' && themeVendor.FlickityFade) {
        new themeVendor.FlickityFade('#spice-flickity', {
            adaptiveHeight: true,
            autoPlay: false,
            contain: true,
            fade: true,
            pageDots: false,
            prevNextButtons: false,
            wrapAround: true,
            arrow: false,
            on: {
                change: function (index) {
                    const spiceThumb = document.querySelector('#spice-thumb');
                    if (spiceThumb?.flickityInstance) {
                        spiceThumb.flickityInstance.select(index);
                    }
                }
            }
        });
    }

    const spiceThumbEl = document.querySelector('#spice-thumb');
    if (spiceThumbEl) {
        spiceThumbEl.flickityInstance = new Flickity(spiceThumbEl, {
            contain: true,
            pageDots: false,
            on: {
                change: function (index) {
                    if (typeof themeVendor !== 'undefined' && themeVendor.FlickityFade) {
                        themeVendor.FlickityFade('#spice-flickity').select(index);
                    }
                }
            }
        });

        spiceThumbEl.querySelectorAll('.thumb, .thumb a').forEach(el => {
            el.addEventListener('click', function (e) {
                e.preventDefault();
                const mediaId = this.getAttribute('data-media-id') || this.parentNode.getAttribute('data-media-id');
                const index = Array.from(document.querySelectorAll('#spice-flickity [data-media-id]')).findIndex(el => el.getAttribute('data-media-id') === mediaId);
                if (index !== -1) {
                    spiceThumbEl.flickityInstance.select(index);
                }
            });
        });
    }
    if (callback) callback();
}

function updateBeforeAfterImages() {
    const slider = document.getElementById('before-after-slider');
    const before = document.getElementById('before-image');
    if (before != undefined) {
        const beforeImage = before.getElementsByTagName('img')[0];
        const afterImage = document.getElementById('after-image').getElementsByTagName('img')[0];
        const resizer = document.getElementById('resizer');

        function adjustImageSizes() {
            let sliderWidth = slider.offsetWidth;

            beforeImage.style.width = sliderWidth + 'px';
            afterImage.style.width = sliderWidth + 'px';

            before.style.width = (sliderWidth / 2) + "px";
            resizer.style.left = (sliderWidth / 2) + "px";
        }

        function slideIt(x) {
            let transform = Math.max(0, Math.min(x, slider.offsetWidth));
            before.style.width = transform + "px";
            resizer.style.left = transform + "px";
        }

        if (slider && resizer) {
            window.addEventListener('resize', adjustImageSizes);
            slider.addEventListener('mousemove', function (e) {
                let x = e.pageX - slider.getBoundingClientRect().left;
                slideIt(x);
            });
            slider.addEventListener('touchmove', function (e) {
                let x = e.touches[0].pageX - slider.getBoundingClientRect().left;
                slideIt(x);
                e.preventDefault();
            });
            adjustImageSizes();
        }
    }
    onElementReady('.eq-pdp-section .jdgm-prev-badge__text', () => {
        //console.log('rating exists');
        if (document.querySelector('.eq-pdp-section .jdgm-prev-badge') && document.querySelector('.eq-pdp-section .jdgm-prev-badge__text')) {
            const rating = document.querySelector('.eq-pdp-section .jdgm-prev-badge').dataset.averageRating;
            // update the rating with only one precision
            const ratingNumber = parseFloat(rating).toFixed(1);
            const ratingPeople = document.querySelector('.eq-pdp-section .jdgm-prev-badge__text').textContent.replace(" reviews", "");
            //language=HTML
            if (ratingPeople && ratingPeople !== 'No' && ratingNumber > 0) {
                document.querySelector('.eq-pdp-section  .jdgm-prev-badge').innerHTML = `
                    <span>Rated <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17"
                                     viewBox="0 0 16 17"
                                     fill="none">
                    <path d="M16 6.14374L11.25 9.73749L12.9375 16.05L8 12.2687L3.0625 16.05L4.75 9.73749L0 6.14374H5.8125L8 0.0499878L10.1875 6.14374H16Z"
                          fill="#1A1A1A"/>
                    </svg> <strong>${ratingNumber}</strong> by ${ratingPeople} happy customers</span>
                `
                document.querySelector('.eq-pdp-section  .jdgm-preview-badge').classList.add('display-block')
            } else {
                document.querySelector('.eq-pdp-section  .jdgm-preview-badge').classList.add('display-none')
            }
        } else {
            const ratingPeople = document.querySelector('.eq-pdp-section .jdgm-prev-badge__text').textContent.replace(" reviews", "");
            //language=HTML
            if (ratingPeople && ratingPeople !== 'No' && ratingNumber > 0) {
                document.querySelector('.eq-pdp-section  .jdgm-prev-badge').innerHTML = `
                    <span>Rated <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17"
                                     viewBox="0 0 16 17"
                                     fill="none">
                    <path d="M16 6.14374L11.25 9.73749L12.9375 16.05L8 12.2687L3.0625 16.05L4.75 9.73749L0 6.14374H5.8125L8 0.0499878L10.1875 6.14374H16Z"
                          fill="#1A1A1A"/>
                    </svg> <strong>5.0</strong> by ${ratingPeople} happy customers</span>
                `
                document.querySelector('.eq-pdp-section  .jdgm-preview-badge').classList.add('display-block')
            } else {
                document.querySelector('.eq-pdp-section  .jdgm-preview-badge').classList.add('display-none')
            }
        }
    })
}

document.addEventListener("DOMContentLoaded", () => {
    updateBeforeAfterImages();
    let waitforImages = setInterval(() => {
        if (document.querySelector('[data-thumbs-slider]') && typeof Flickity === 'function') {
            clearInterval(waitforImages);
            window['eq-pdp-page-update']();
        }
    }, 300);
});


function loadFlickityScript() {
    var flickityScript = document.createElement('script');
    flickityScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/flickity/2.3.0/flickity.pkgd.min.js';
    document.head.appendChild(flickityScript);
}

function loadFlickityCSS() {
    var flickityCSS = document.createElement('link');
    flickityCSS.rel = 'stylesheet';
    flickityCSS.href = 'https://cdnjs.cloudflare.com/ajax/libs/flickity/2.3.0/flickity.min.css';
    document.head.appendChild(flickityCSS);
    flickityCSS.onload = loadFlickityScript;
}

function checkJQuery() {
    if (typeof (window.jQuery) === 'function') {
        // loadFlickityCSS();
        clearInterval(intervalSlick);
    }
}

let intervalSlick = setInterval(checkJQuery, 100);
// Our common onElementReady function
function onElementReady(selector, callback) {
    const element = document.querySelector(selector);
    if (element) {
        callback();
    } else {
        const observer = new MutationObserver((mutations, me) => {            
            const el = document.querySelector(selector);
            if (el) {
                callback();
                me.disconnect();
            }
        });
        observer.observe(document, {
            childList: true,
            subtree: true
        });
    }
}

function customMutation(selector) {
    onElementReady(selector, (e) => {
        let selectElement = document.querySelector(selector);    
        if (selectElement) {
            selectElement.addEventListener('change', function () {
                setTimeout(() => {
                    destroyFlickity();
                    initFlickity(() => {
                        if (typeof jQuery === 'function') {
                        jQuery('#spice-thumb .thumb, #spice-thumb .thumb a').eq(0).trigger('click');
                    } else {
                        console.warn('jQuery is not loaded.');
                    }
                    });
                }, 300);
            });
        }
    })
}

customMutation('select[name="reviewer_name_format"]');
customMutation('select.jdgm-sort-dropdown');